import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { inject } from '@angular/core/primitives/di';
import { InstallWP, TemporaryWPCredentials } from '../../shared/models/wordpress.models';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class WPCliService {
  private http = inject(HttpClient);

  public getWPStatus(websiteId: number): Observable<void> {
    return this.http.get<void>(`/wp-cli/${websiteId}/check`);
  }

  public installWp(data: InstallWP): Observable<void> {
    return this.http.post<void>('/wp-cli/install', data);
  }

  public saveTempCredentials(data: TemporaryWPCredentials): Observable<void> {
    return this.http.post<void>('/wp-cli/credentials', data);
  }

  public uninstallWp(websiteId: number): Observable<void> {
    return this.http.delete<void>(`/wp-cli/${websiteId}`);
  }
}
